// Card image aspect ratio (width / height). Also mirrored by the
// `aspect-ratio` on .picker-preview in index.css.
export const CARD_RATIO = 0.714

// Single source of truth for the mobile breakpoint.
// index.css can't import this — keep its `@media (max-width: 615px)`
// block in sync by hand.
export const SMALL_APP_WIDTH = 615

export const MOBILE_MEDIA_QUERY = `(max-width: ${SMALL_APP_WIDTH}px)`

// matches the CSS media query by definition (same axis, same width),
// so JS "small" and CSS "small" can never disagree
export const isSmallViewport = () =>
  typeof window !== "undefined" &&
  window.matchMedia(MOBILE_MEDIA_QUERY).matches
